export default __webpack_public_path__ + "static/media/CustomerSupport.8109b1df.png";